/* global axios */
import ApiClient from './ApiClient';

class RawDataAPI extends ApiClient {
  constructor() {
    super('raw_data', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  search({ q, page = 1, perPage = 15 }) {
    return axios.get(`${this.url}/search`, {
      params: { q, page, per_page: perPage },
    });
  }

  filter(params) {
    return axios.post(`${this.url}/filter`, params);
  }

  import(file, source = 'csv') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('source', source);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  export(params = {}) {
    return axios.get(`${this.url}/export`, {
      params,
      responseType: 'blob',
    });
  }

  bulkResolve({ inboxId, rawDatumIds }) {
    return axios.post(`${this.url}/bulk_resolve`, {
      inbox_id: inboxId,
      raw_datum_ids: rawDatumIds,
    });
  }
}

export default new RawDataAPI();
